import React from 'react';
import { BsTwitter, BsInstagram, BsGithub, BsWhatsapp } from 'react-icons/bs';
import { GrLinkedin } from 'react-icons/gr';

const SocialMedia = () => (
  <div className="app__social" style={{position:"fixed", bottom:"3rem", left:"0", zIndex:"4"}}>
    <a href="https://www.linkedin.com/in/krishn-panchal-665388201/" target="_blank" rel="noreferrer">
        <div><GrLinkedin /></div>
    </a>
    <a href="https://github.com/phovious-14" target="_blank" rel="noreferrer">
        <div><BsGithub /></div>
    </a>
    <a href="https://api.whatsapp.com/send?phone=9974628189" target="_blank" rel="noreferrer">
        <div><BsWhatsapp /></div>
    </a>
    <a href="https://twitter.com/krishnpanchal14" target="_blank" rel="noreferrer">
        <div><BsTwitter /></div>
    </a>
    <a href="https://www.instagram.com/krishn_panchal_14/" target="_blank" rel="noreferrer">
        <div><BsInstagram /></div>
    </a>
  </div>
);

export default SocialMedia;